@switch (account().accountStatus | lowercase) {
  @case ('paid in full') {
    <app-account-item
      [accountTitle]="accountTitle()"
      [accountStatus]="account().accountStatus"
      [autoPayEnrollment]="autoPayEnrollmentDisplay()"
      [showAutoPay]="false"
      [testId]="loanAccountTestId()"
      (onTitleClick)="emitLoanClick()"
    >
      <div class="amount-details-row">
        <div class="amount-details-row__amounts">
          <app-amount-display
            heading="payoff amount*"
            [dollarAmount]="account().payoffAmount"
            [testId]="'customer-hub-loan-payoff-amount'"
            class="loan-payoff-amount"
            id="loanPayoffAmount"
          ></app-amount-display>
        </div>
        <div class="amount-details-row__buttons">
          <a class="link-view-acct" data-test-id="customer-hub-loan-view-account-link" (click)="emitLoanClick()">View account</a>
        </div>
      </div>
    </app-account-item>
  }
  @case ('closed') {
    <app-account-item
      [accountTitle]="accountTitle()"
      [accountStatus]="account().accountStatus"
      [autoPayEnrollment]="autoPayEnrollmentDisplay()"
      [showAutoPay]="false"
      [testId]="loanAccountTestId()"
      (onTitleClick)="emitLoanClick()"
    >
      <div
        class="p-4 rounded-lg bg-navy-50 be-text-sm text-navy-800 border border-navy-200"
      >
        <p class="closed-message">
          This account is closed. We are not able to service closed accounts
          online.
          <span class="font-medium"
            >Please call us at
            @if (account().productType === 'Vehicle Equity Loan') {
              <a href="tel:8662102842">866-210-2842</a>
            } @else {
              <a href="tel:8552826353">855-282-6353</a>
            }
            for assistance.</span
          >
        </p>
      </div>
    </app-account-item>
  }
  @default {
    <app-account-item
      [accountTitle]="accountTitle()"
      [accountStatus]="account().accountStatus"
      [autoPayEnrollment]="autoPayEnrollmentDisplay()"
      [showAutoPay]="true"
      [testId]="loanAccountTestId()"
      (onTitleClick)="emitLoanClick()"
    >
      <div class="amount-details-row">
        <div class="amount-details-row__amounts">
          @if (account().nextDueDate) {
            <app-amount-display
              heading="payment due"
              [dollarAmount]="nextPaymentAmountDue()"
              [subtitle]="
                'Due on ' + (account().nextDueDate | date: 'MM/dd/yyyy')
              "
              class="loan-payment-due"
            ></app-amount-display>
          }
          <app-amount-display
            heading="payoff amount*"
            [dollarAmount]="account().payoffAmount"
            [testId]="'customer-hub-loan-payoff-amount'"
            class="loan-payoff-amount"
          ></app-amount-display>
        </div>
        <div class="amount-details-row__buttons">
          <app-be-button
            size="small"
            type="button"
            variant="ghost"
            class="view-acct-btn"
            data-test-id="customer-hub-loan-view-account-button"
            (click)="emitLoanClick()"
            [isDisabled]="isPaymentsDisabled$ | async"
          >
            View account
          </app-be-button>
          <app-be-button
            size="small"
            type="button"
            class="make-payment-btn"
            data-test-id="customer-hub-loan-make-payment-button"
            (click)="emitLoanMakePaymentClick()"
            [isDisabled]="isPaymentsDisabled$ | async"
          >
            Make a payment
          </app-be-button>
        </div>
      </div>
      <ul class="flex flex-col">
        @for (notification of accountNotifications(); track notification.id) {
          <li class="mt-4 notification-li">
            <app-notification class="block w-full notification-text">
              <app-payment-notification
                [accountId]="account().id"
                [notification]="notification"
                [baseHrefUrl]="baseUrl()"
              ></app-payment-notification>
            </app-notification>
          </li>
        }
      </ul>
      @if (dueDateIsClose()) {
        <div class="due-date-banner">
          <div>
            <span class="calender-icon"
              ><app-icon-calender></app-icon-calender
            ></span>
          </div>
          <div class="due-date-content">
            <p class="due-date-text">
              Your loan payment is due on
              <span class="font-bold">{{
                account().nextDueDate | date: 'MM/dd/yyyy'
              }}</span
              >. If you need more time, you can change your due date.
            </p>
            <app-be-button
              variant="alt-link"
              size="small"
              class="due-date-btn"
              data-test-id="customer-hub-loan-change-due-date-button"
              (click)="emitChangeDueDateClick()"
              >Change Due Date</app-be-button
            >
          </div>
        </div>
      }
    </app-account-item>
  }
}
